import React from 'react'

const YoutubeEmbed = ({ videoId }) => {
    return (
        <div className="w-full lg:w-[750px] mx-auto">
            <div className="aspect-video">
                <iframe
                    className="w-full h-full rounded-2xl shadow-2xl border border-purple-700"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title="Embedded YouTube Video"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    )
}

export default YoutubeEmbed
